<template lang='pug'>
  div
    v-row
      v-col
        h1 履歴検索
      v-col
        v-card(min-width="220", flat, class="timecell ml-2", width='220')
          v-menu(v-model='datesmenu', :close-on-content-click='false',transition='scale-transition', offset-y)
            template(v-slot:activator="{ on }")
              v-text-field(v-model='dateRangeText', label='検索期間', v-on="on", dense, readonly, class="timeinput", width='220', class="centered-input")
            v-date-picker(v-model='dates', range, no-title, @input='checkRange')
    v-row(class="timerow")
      v-data-table(:items='timesheets', :headers='headers', class='timesheet-table', :items-per-page='50')
        template(slot='body.append')
          tr
            th 合計
            th
            th
            th {{total}}
            th
    v-dialog(v-model='dialog', max-width='250')
      v-card-title Koos Workspace
      v-card-text {{dialogMessage}}
      v-card-action
        v-btn(text, @click='dialog = false') OK
</template>

<script>
import basic from '@/components/mixins/basic'
import { detect } from 'detect-browser';

export default {
  mixins: [basic],
  components: {
  },
  computed: {
    items: { get() { return this.$store.state.Masters.Workers }} ,
    dateRangeText () { return this.dates.join(' ~ ') }
  },
  data() {
    return {
      headers: [
        {text: '開始', value:'startedClientF'}, 
        {text: '終了', value:'endedClientF'},
        {text: '休憩(分)', value:'breakTimespan'},
        {text: '合計', value:'total'},
        {text: 'メモ', value:'comment'},
      ],
      dates: [],
      datesmenu: false,
      timesheets : [],
      browser : null,
      dateStyle: 'picker',
      timeStyle: 'text',
      dialog: false,
      dialogMessage: '',
      totalDuration: 0,
      total:''
    }
  },
  mounted() {
    this.browser = detect()
    if (this.browser !== null) {
      if (this.browser.os.includes('iOS') || this.browser.os.includes('Android')) {
        this.dateStyle = 'input'
        this.timeStyle = 'time'
      }
    }
  },
  methods: {
    async masterReady (){
      await this.search()
    },
    async search () {
      if (this.dates != null && this.dates.length == 2) {
        this.timesheets = await this.$store.dispatch("Timesheet/getMyTimesheetHistory", {startdate: this.dates[0], enddate: this.dates[1]});
        this.totalDuration = this.timesheets.reduce((total, element) => {
          return total + parseInt(element.dulationMin) 
        }, 0)
        this.total = (Math.floor(this.totalDuration / 60)).toString() + ':' + (this.totalDuration % 60).toString().padStart(2, '0') 
      } else {
        this.timesheets = []
        this.total = ''
      }
    },
    async checkRange() {
      if (this.dates != null && this.dates.length == 2) {
        this.datesmenu = false;
        this.search()
      }
    }
  }
};
</script>

<style lang='scss'>
.timesheet-table {
  width: 100%;
}
</style>